import React from 'react';
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import about from '../../images/blog/about-widget.jpg'
import blogs from '../../api/blogs'

const SubmitHandler = (e) => {
    e.preventDefault()
}

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const BlogSidebar = (props) => {
    return (
        <div className={`col col-lg-4 col-12 ${props.blLeft}`}>
            <div className="blog-sidebar">
                <div className="widget about-widget">
                    <div className="img-holder">
                        <img src={about} alt="" />
                    </div>
                    <h4>Linda Johns</h4>
                    <p>Hi! beautiful people. I`m an authtor of this blog. Read our post - stay with us</p>
                    <div className="social">
                        <ul className="clearfix">
                            <li><Link onClick={ClickHandler} to="/newsroom"><i className="ti-facebook"></i></Link></li>
                            <li><Link onClick={ClickHandler} to="/newsroom"><i className="ti-twitter-alt"></i></Link></li>
                            <li><Link onClick={ClickHandler} to="/newsroom"><i className="ti-linkedin"></i></Link></li>
                            <li><Link onClick={ClickHandler} to="/newsroom"><i className="ti-pinterest"></i></Link></li>
                        </ul>
                    </div>
                </div>
                <div className="widget search-widget">
                    <h3>Search Here</h3>
                    <form onSubmit={SubmitHandler}>
                        <div>
                            <input type="text" className="form-control" placeholder="Search Post.." />
                            <button type="submit"><i className="ti-search"></i></button>
                        </div>
                    </form>
                </div>
                <div className="widget category-widget">
                    <h3>Post Categories</h3>
                    <ul>
                        <ul>
                            <li><Link onClick={ClickHandler} to="/newsroom">Neurology<span>5</span></Link></li>
                            <li><Link onClick={ClickHandler} to="/newsroom">Urology<span>7</span></Link></li>
                            <li><Link onClick={ClickHandler} to="/newsroom">Bags<span>3</span></Link></li>
                            <li><Link onClick={ClickHandler} to="/newsroom">HIV/AIDS<span>6</span></Link></li>
                            <li><Link onClick={ClickHandler} to="/newsroom">Gestrology<span>2</span></Link></li>
                            <li><Link onClick={ClickHandler} to="/newsroom">Dermatology<span>8</span></Link></li>
                            <li><Link onClick={ClickHandler} to="/newsroom">Otolaryngology<span>7</span></Link></li>
                        </ul>
                    </ul>
                </div>
                <div className="widget recent-post-widget">
                    <h3>Related Posts</h3>
                    <div className="posts">
                        {blogs.slice(0, 3).map((blog, bl) => (
                            <div className="post" key={bl}>
                                <div className="img-holder">
                                    <img src={blog.screens} alt="" />
                                </div>
                                <div className="details">
                                    <h4><Link onClick={ClickHandler} to={`/newsroom/${blog.slug}`}>{blog.title2}</Link></h4>
                                    <span className="date">{blog.create_at}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="widget tag-widget">
                    <h3>Tags</h3>
                    <ul>
                        <li><Link onClick={ClickHandler} to="/newsroom">Health</Link></li>
                        <li><Link onClick={ClickHandler} to="/newsroom">Beauty</Link></li>
                        <li><Link onClick={ClickHandler} to="/newsroom">Heart</Link></li>
                        <li><Link onClick={ClickHandler} to="/newsroom">Doctor</Link></li>
                        <li><Link onClick={ClickHandler} to="/newsroom">Hospital</Link></li>
                        <li><Link onClick={ClickHandler} to="/newsroom">Nurocare</Link></li>
                        <li><Link onClick={ClickHandler} to="/newsroom">Dental</Link></li>
                        <li><Link onClick={ClickHandler} to="/newsroom">Dermatologist</Link></li>
                        <li><Link onClick={ClickHandler} to="/newsroom">Pediatrician</Link></li>
                    </ul>
                </div>
            </div>
        </div>
    )

}

export default BlogSidebar;
